import { gql } from '@apollo/client';

export const GET_BUSINESS_FUNCTIONS = gql`
  query GetBusinessFunctions($filter: BusinessFunctionFilterInput) {
    getBusinessFunctions(filter: $filter) {
      description
      name
      selected
      uuid
    }
  }
`;

export const GET_BUSINESS_FUNCTION = gql`
  query GetBusinessFunction($uuid: String!) {
    getBusinessFunction(uuid: $uuid) {
      description
      name
      selected
      uuid
    }
  }
`;

export const CREATE_BUSINESS_FUNCTION = gql`
  mutation CreateBusinessFunction($data: CreateBusinessFunctionInput!) {
    createBusinessFunction(data: $data) {
      description
      name
      selected
      uuid
    }
  }
`;

export const UPDATE_BUSINESS_FUNCTION = gql`
  mutation UpdateBusinessFunction($data: UpdateBusinessFunctionInput!) {
    updateBusinessFunction(data: $data) {
      description
      name
      selected
      uuid
    }
  }
`;

export const UPDATE_LOCATION_BUSINESS_FUNCTION_SUPPORT = gql`
  mutation UpdateLocationBusinessFunctionSupport(
    $locationUUID: String!
    $businessFunctionUUID: String!
    $supportedByITApplication: Boolean!
  ) {
    updateLocationBusinessFunctionSupport(
      locationUUID: $locationUUID
      businessFunctionUUID: $businessFunctionUUID
      supportedByITApplication: $supportedByITApplication
    )
  }
`;

export const DELETE_BUSINESS_FUNCTION = gql`
  mutation DeleteBusinessFunction($uuid: String!) {
    deleteBusinessFunction(uuid: $uuid)
  }
`;
